import React, { useState, useEffect } from "react";
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Grid,
  IconButton,
  Typography,
  useMediaQuery,
} from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import {
  ArrayField,
  Button,
  Datagrid,
  TextField,
  useRecordContext,
} from "react-admin";
import {
  CloseIcon,
  KeyboardOutlinedIcon,
  ScannerIcon,
} from "../../../components/common/iconography";

const useStyles = makeStyles((theme) => ({
  dialogTitle: {
    display: "flex",
    paddingTop: "5px",
    paddingBottom: "5px",
    justifyContent: "space-between",
  },
  title: {
    paddingTop: theme.spacing(1),
  },
  dialogContent: {
    minHeight: "50vh",
  },
  tableCellIcon: {
    padding: "3px",
    textAlign: "center",
    height: "33px",
  },
}));
const BooleanIconField = ({ source }) => {
  const record = useRecordContext();
  if (!record) return null;
  return record[source] ? (
    <ScannerIcon fontSize="small" />
  ) : (
    <KeyboardOutlinedIcon fontSize="small" />
  );
};

export const SealNumbersDialog = ({ open, onClose, formData }) => {
  const [validSeals, setValidSeals] = useState({ items: [] });
  const classes = useStyles();
  const isSmall = useMediaQuery((theme) => theme.breakpoints.down("xs"));

  useEffect(() => {
    if (formData?.seals?.items) {
      const updatedSeals = formData.seals.items.filter((el) => el.validated);
      setValidSeals({ items: updatedSeals });
    }
  }, [formData?.seals?.items]);

  const handleClose = () => {
    onClose();
  };

  return (
    <Dialog
      open={open}
      onClose={handleClose}
      maxWidth={isSmall ? "xxl" : "lg"}
      fullWidth
    >
      <DialogTitle disableTypography className={classes.dialogTitle}>
        <Typography className={classes.title} variant="h6">
          Seal Manager
        </Typography>
        <IconButton aria-label="close" onClick={handleClose}>
          <CloseIcon fontSize="large" />
        </IconButton>
      </DialogTitle>
      <DialogContent dividers className={classes.dialogContent}>
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <ArrayField
              source="items"
              label="Valid seals"
              fullWidth
              record={validSeals}
            >
              <Grid container direction="row">
                <Grid item xs={12} md={1}>
                  <Datagrid>
                    <BooleanIconField
                      source="isScanned"
                      label="&nbsp;"
                      fullWidth
                      emptyText="&nbsp;"
                      cellClassName={classes.tableCellIcon}
                    />
                  </Datagrid>
                </Grid>
                <Grid item xs={12} md={4}>
                  <Datagrid>
                    <TextField source="barcode" fullWidth emptyText="&nbsp;" />
                  </Datagrid>
                </Grid>
                <Grid item xs={12} md={3}>
                  <Datagrid>
                    <TextField
                      source="createdBy"
                      label="Entered By"
                      fullWidth
                      emptyText="&nbsp;"
                    />
                  </Datagrid>
                </Grid>
                <Grid item xs={12} md={4}>
                  <Datagrid>
                    <TextField
                      source="description"
                      fullWidth
                      emptyText="&nbsp;"
                    />
                  </Datagrid>
                </Grid>
              </Grid>
            </ArrayField>
          </Grid>
        </Grid>
      </DialogContent>
      <DialogActions>
        <Button onClick={handleClose} label="Close" color="default" />
      </DialogActions>
    </Dialog>
  );
};
